// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay';


import 'vue-material/dist/vue-material.min.css'
import VueMaterial from 'vue-material'
import 'mapbox-gl/dist/mapbox-gl.css'
import 'mapbox-gl-controls/theme.css'
import 'mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

import VModal from 'vue-js-modal'

Vue.use(VueMaterial);
Vue.use(VModal);

import { Settings } from 'luxon'

Settings.defaultLocale = 'de';


Vue.use(Loading, {
  color: 'blue',
  canCancel: false,
  height: 100,
  width: 100,
  opacity: 0.7
});

// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VueCookies);

Vue.config.errorHandler = (err, vm, info) => {
  if (process.env.NODE_ENV !== 'production') {
    // Show any error but this one
    if (err.message !== "Cannot read property 'badInput' of undefined") {
      console.error(err);
    }
  }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
});


Vue.http.interceptors.push(function(request) {
  request.credentials=true;
});
